// Bilingual content dictionary. Danish is the primary market language.
// Structured so more languages can be added later by adding a new top-level key.

export const translations = {
  da: {
    langName: "Dansk",
    nav: {
      pax: "PAX-montering",
      other: "Øvrige IKEA-møbler",
      kitchen: "IKEA-køkken",
      area: "Serviceområde",
      how: "Sådan gør vi",
      cta: "Få din samlepris",
      menu: "Menu",
    },
    common: {
      inclVat: "inkl. 25% moms",
      vatBadge: "Alle priser inkl. 25% moms",
      from: "Fra",
      postcode: "Postnummer",
      getPrice: "Få din samlepris",
      book: "Book montering",
      requestQuote: "Anmod om tilbud",
      next: "Næste",
      back: "Tilbage",
      submit: "Send anmodning",
      submitting: "Sender...",
      optional: "valgfrit",
      required: "påkrævet",
      loading: "Indlæser...",
      close: "Luk",
    },
    hero: {
      eyebrow: "Uafhængig dansk montageservice",
      subtitle:
        "Professionelle montører samler dine IKEA-møbler hurtigt, sikkert og til en fast pris. Få prisen på under et minut — helt uforpligtende.",
      point1: "Fast pris — ingen overraskelser",
      point2: "Erfarne montører med eget værktøj",
      point3: "Vægfæstning inkluderet for sikkerhed",
      ctaSecondary: "Se sådan gør vi",
    },
    how: {
      title: "Sådan gør vi",
      subtitle: "Fire enkle trin fra bestilling til færdigt møbel.",
      step1Title: "Vælg møbeltype",
      step1: "Fortæl os hvilke IKEA-møbler du har fået leveret.",
      step2Title: "Få din pris",
      step2: "PAX får du med det samme. Øvrigt sender vi et hurtigt tilbud på.",
      step3Title: "Vælg dato",
      step3: "Indtast postnummer og vælg et tidspunkt der passer dig.",
      step4Title: "Vi samler",
      step4: "En erfaren montør samler dine møbler — du læner dig tilbage.",
    },
    services: {
      title: "Vores montageydelser",
      subtitle: "Vi er specialister i IKEA-møbelmontering.",
      paxTitle: "PAX garderobe",
      paxDesc: "Få en fast pris med det samme med vores prisberegner.",
      paxCta: "Beregn PAX-pris",
      otherTitle: "Øvrige IKEA-møbler",
      otherDesc: "Senge, kommoder, reoler, sofaer, borde og meget mere.",
      otherCta: "Anmod om tilbud",
      kitchenTitle: "IKEA-køkken",
      kitchenDesc: "Montering og installation efter aftalt omfang.",
      kitchenCta: "Anmod om køkkentilbud",
      instant: "Straks-pris",
      quote: "Tilbud",
    },
    why: {
      title: "Hvorfor vælge os",
      subtitle: "En pålidelig lokal service med fokus på kvalitet.",
      item1Title: "Fast prisgaranti",
      item1: "Du kender prisen inden vi starter. Ingen ubehagelige overraskelser.",
      item2Title: "Erfarne montører",
      item2: "Rutinerede montører med professionelt værktøj og erfaring med IKEA.",
      item3Title: "Sikker montering",
      item3: "Vægfæstning af høje møbler er inkluderet af hensyn til sikkerheden.",
      item4Title: "Uafhængig service",
      item4: "Vi er en selvstændig virksomhed — ikke tilknyttet IKEA.",
    },
    area: {
      title: "Serviceområde",
      subtitle: "Vi dækker primært København og Nordsjælland. Øvrige områder på Sjælland efter aftale. Tjek dit postnummer.",
      placeholder: "Indtast postnummer",
      check: "Tjek",
      supported: "Vi dækker dit område",
      supportedFee: "Kørsel til dette område:",
      free: "Gratis kørsel",
      notSupported: "Vi dækker desværre ikke dette postnummer endnu. Kontakt os gerne.",
      invalid: "Indtast et gyldigt dansk postnummer.",
      zone: "Zone",
    },
    gallery: {
      title: "Udvalgt arbejde",
      subtitle: "Eksempler på montering vi udfører til daglig.",
    },
    faq: {
      title: "Ofte stillede spørgsmål",
      q1: "Hvad koster det at få samlet en PAX-garderobe?",
      a1: "Prisen afhænger af antal sektioner, låger, skuffer og tilbehør. Brug vores prisberegner og få en fast pris med det samme — inkl. 25% moms.",
      q2: "Leverer I møblerne?",
      a2: "Nej. Vi samler de IKEA-møbler, du allerede har fået leveret. Det holder prisen lav og enkel.",
      q3: "Er I tilknyttet IKEA?",
      a3: "Nej. Vi er en uafhængig montageservice og har ingen tilknytning til IKEA.",
      q4: "Fæstner I møblerne til væggen?",
      a4: "Ja. Vægfæstning af høje møbler er inkluderet af sikkerhedshensyn, hvor det er relevant.",
      q5: "Hvordan betaler jeg?",
      a5: "Du modtager en bekræftelse med den faste pris. Betaling aftales i forbindelse med booking.",
    },
    finalCta: {
      title: "Klar til at få samlet dine møbler?",
      subtitle: "Få din faste pris på under et minut.",
    },
    pax: {
      heroTitle: "PAX garderobe-montering",
      heroSubtitle:
        "Få en fast pris på montering af din PAX-garderobe med det samme. Konfigurer din opstilling nedenfor.",
      calcTitle: "PAX prisberegner",
      calcSubtitle: "Vælg din opstilling — prisen opdateres automatisk.",
      sections: "Antal PAX-sektioner (rammer)",
      frameWidth: "Bredde pr. sektion",
      frameHeight: "Højde",
      hingedDoors: "Hængslede låger",
      slidingDoors: "Skydedørssæt",
      drawers: "KOMPLEMENT skuffer",
      baskets: "Trådkurve",
      shelves: "Hylder",
      rails: "Bøjlestænger",
      handles: "Håndtag/greb",
      lighting: "Lyspakker",
      wallMounting: "Vægfæstning (anbefales)",
      wallMountingIncluded: "Inkluderet",
      yourPrice: "Din pris",
      priceNote: "Fast pris inkl. 25% moms",
      breakdown: "Prisspecifikation",
      travel: "Kørsel",
      discount: "Rabat",
      belowMin: "Minimumsbeløb pr. opgave er",
      enterPostcode: "Indtast postnummer for at se den endelige pris inkl. kørsel.",
      notSupported: "Vi dækker ikke dette postnummer endnu — kontakt os gerne.",
      bookThis: "Book denne opstilling",
      cm: "cm",
      chooseMethod: "Få din PAX-monteringspris",
      chooseSubtitle: "Vælg den nemmeste måde for dig.",
      uploadOption: "Upload din IKEA-bestilling eller PAX-plan",
      uploadFast: "Hurtigste måde",
      uploadDesc: "Vi finder delene og beregner monteringsprisen for dig.",
      uploadPdf: "Upload PDF",
      uploadPhoto: "Upload skærmbillede/foto",
      orManual: "Eller beregn manuelt",
      manualOption: "Beregn manuelt",
      recommended: "Anbefalet",
      analyzing: "Analyserer din bestilling...",
      recognizeFailed: "Kunne ikke læse filen. Prøv en anden fil eller beregn manuelt.",
      foundTitle: "Vi fandt følgende",
      foundSubtitle: "Bekræft eller ret antallene, før vi beregner prisen.",
      recognizedItems: "Genkendte varer",
      lowConfidence: "Usikker genkendelse — tjek venligst",
      confirmContinue: "Bekræft og se pris",
      editManually: "Ret manuelt",
      startOver: "Start forfra",
      trays: "Udtræksbakker",
      trouserHangers: "Buksebøjler (udtræk)",
      multiHangers: "Multibøjler (udtræk)",
      otherPullouts: "Andet udtræk/mekanik",
      otherUnknown: "Andet / ukendt element",
      infoOnly: "Kun til info — påvirker ikke prisen",
      includedNote: "Standardprisen inkluderer rammer, døre, håndtag, hylder, stænger og almindeligt KOMPLEMENT-inventar.",
      interiorTitle: "Indvendigt (KOMPLEMENT)",
      doorsTitle: "Låger",
      fixedPrice: "Fast monteringspris",
      preliminaryPrice: "Foreløbig monteringspris",
      fixedNote: "Fast pris inkl. 25% moms",
      preliminaryNote: "Endelig pris kræver en hurtig bekræftelse",
      reasonHeavy: "Meget udtræksinventar registreret",
      reasonSliding: "Skydedøre registreret. Vi bekræfter den endelige pris, før du booker.",
      reasonLighting: "Belysning/el registreret",
      reasonUnknown: "Ukendt element registreret",
      reasonLarge: "Stor ordre — kræver intern gennemgang",
      reasonLowConfidence: "Usikker genkendelse — bekræftes manuelt",
      mirrorDoors: "Spejllåger (hængslede)",
      handles: "Håndtag",
      shoeShelf: "Udtræks-skohylde",
      frameDividers: "KOMPLEMENT opdeler til stel",
      cornerSections: "Hjørne-sektion",
      packagingTitle: "Emballage",
      packagingRemoval: "Fjern emballage (bortkørsel)",
      packagingKeep: "Uden bortkørsel samler vi emballagen pænt ét sted hos dig.",
      inclVat: "inkl. 25% moms",
      reviewIntro: "Denne konfiguration kræver en hurtig bekræftelse:",
      bookPreliminary: "Anmod om bekræftet pris",
    },
    other: {
      heroTitle: "Montering af øvrige IKEA-møbler",
      heroSubtitle:
        "Senge, kommoder, reoler, sofaer, borde og meget mere. Fortæl os hvad du har, så sender vi et hurtigt tilbud.",
      productsTitle: "Hvilke møbler skal samles?",
      addProduct: "Tilføj møbel",
      productName: "Produktnavn (fx MALM, HEMNES, BILLY)",
      articleNo: "IKEA-artikelnummer",
      qty: "Antal",
      remove: "Fjern",
      uploadTitle: "Upload IKEA-ordre eller billeder",
      uploadDesc:
        "Upload gerne din IKEA-ordrebekræftelse (PDF/skærmbillede) eller billeder af møblerne. Det hjælper os med at give et præcist tilbud.",
      uploadStep: "1. Upload din IKEA-ordre",
      uploadHint: "IKEA-ordrebekræftelse, produktliste, skærmbillede eller foto (PDF/JPG/PNG). Vores AI læser varerne — den beregner aldrig prisen.",
      analyze: "Analysér ordre",
      analyzing: "Analyserer…",
      analyzeFailed: "Kunne ikke analysere filen. Tilføj venligst varerne manuelt.",
      fillManually: "Udfyld manuelt",
      recognizedTitle: "Vi genkendte følgende varer",
      recognizedHint: "Ret antal, fjern forkerte varer eller tilføj dem, vi ikke fandt.",
      lowConfidence: "Nogle varer er usikre — tjek dem venligst.",
      successMsg: "Tak — vi har modtaget din IKEA-ordre. Vi gennemgår den og sender dig en fast monteringspris, før arbejdet bookes.",
      quoteNote:
        "Vi giver et fast tilbud baseret på dine oplysninger. Prisen bekræftes inden vi starter.",
    },
    kitchen: {
      heroTitle: "IKEA-køkken montering & installation",
      heroSubtitle:
        "Vi monterer og installerer dit IKEA-køkken efter et aftalt omfang af arbejde.",
      scopeTitle: "Hvad skal opgaven omfatte?",
      scopeSubtitle: "Vælg de opgaver der er relevante for dit projekt.",
      uploadTitle: "Upload køkkenprojekt & billeder",
      uploadDesc:
        "Upload din IKEA Køkkenplanlægger/projekt, produkt-/ordreliste og billeder af rummet.",
      scopeNotice:
        "Køkkenpriser fastsættes ud fra det bekræftede omfang af arbejde. Ekstra arbejde, der opdages eller ønskes undervejs, er ikke inkluderet, medmindre det godkendes særskilt.",
      legalNotice:
        "Bemærk: El- og VVS-arbejde udføres kun, hvor det er lovligt og udtrykkeligt aftalt, af autoriserede fagfolk.",
      requestQuote: "Anmod om installationstilbud",
      uploadStep: "1. Upload dit køkkenprojekt",
      uploadHint: "IKEA Køkkenplanlægger (PDF), tegning, produktliste, screenshots og evt. billeder af rummet.",
      analyze: "Analysér projekt",
      analyzing: "Analyserer projekt...",
      analyzeFailed: "Kunne ikke analysere filen. Udfyld venligst manuelt.",
      fillManually: "Udfyld manuelt",
      summaryStep: "2. Vi fandt følgende — ret gerne",
      summaryHint: "Bekræft eller ret oplysningerne. AI beregner ikke pris.",
      layoutLabel: "Køkkenopstilling",
      layouts: { straight: "Lige", l: "L-formet", u: "U-formet", island: "Ø", peninsula: "Halvø", other: "Andet", unknown: "Ved ikke" },
      baseCabinets: "Underskabe", wallCabinets: "Overskabe", tallCabinets: "Højskabe", cornerCabinets: "Hjørneskabe",
      worktop: "Bordplader", worktopLength: "Bordpladelængde (cm, hvis kendt)", sink: "Vask", oven: "Ovn", hob: "Kogeplade",
      dishwasher: "Opvaskemaskine", fridge: "Køle/frys", hood: "Emhætte", island: "Køkkenø", coverPanels: "Dæk-/sidepaneler",
      plinth: "Sokkel", lightingK: "Belysning", otherUnknown: "Andet / ukendt",
      recognizedItems: "Genkendte varer",
      lowConfidence: "Nogle elementer er usikre — tjek venligst.",
      questionsStep: "3. Et par hurtige spørgsmål",
      qOldKitchen: "Skal det gamle køkken fjernes?",
      qWorktopInstall: "Skal bordpladen monteres?",
      qSinkCutout: "Udskæring til vask?",
      qHobCutout: "Udskæring til kogeplade?",
      qWallsReady: "Er væggene klar (malet/klargjort)?",
      qAppliances: "Hvidevarer der skal installeres",
      qAppliancesPh: "Fx ovn, kogeplade, emhætte, opvasker, køleskab...",
      optYes: "Ja", optNo: "Nej", optNotSure: "Ved ikke", optNoOld: "Intet gammelt køkken",
      contactStep: "4. Send dit projekt",
      sendProject: "Send projekt",
      regulatedNote: "VVS- og el-arbejde markeres til manuel vurdering og udføres kun af autoriserede fagfolk, hvis det aftales særskilt.",
      successMsg: "Tak — vi har modtaget dit køkkenprojekt. Vi gennemgår projektet og sender dig en fast monteringspris, før arbejdet bookes.",
      noPriceNote: "Køkkenpris fastsættes manuelt efter gennemgang af dit projekt — du får en fast pris, før arbejdet bookes.",
      scopeItems: {
        cabinet_assembly: "Samling af skabe",
        cabinet_installation: "Montering af skabe",
        wall_cabinets: "Overskabe",
        base_cabinets: "Underskabe",
        tall_cabinets: "Højskabe",
        cover_panels: "Dæksider",
        fillers: "Fyldstykker",
        plinth: "Sokkel/fodliste",
        worktop_install: "Montering af bordplade",
        worktop_cutting: "Udskæring i bordplade",
        sink: "Vaskinstallation",
        faucet: "Armatur/vandhane",
        dishwasher: "Opvaskemaskine",
        oven: "Ovn",
        hob: "Kogeplade",
        hood: "Emhætte",
        fridge: "Køleskab",
        lighting: "Belysning",
        removal_old: "Fjernelse af gammelt køkken",
        plumbing: "VVS-ændringer",
        electrical: "El-arbejde",
        other: "Andet specialarbejde",
      },
    },
    booking: {
      title: "Book montering",
      quoteTitle: "Anmod om tilbud",
      step: "Trin",
      of: "af",
      contactTitle: "Dine kontaktoplysninger",
      firstName: "Fornavn",
      lastName: "Efternavn",
      email: "E-mail",
      phone: "Telefon",
      postcode: "Postnummer",
      address: "Adresse",
      addressNote: "Bruges kun til at planlægge besøget.",
      dateTitle: "Ønsket dato & tidspunkt",
      preferredDate: "Ønsket dato",
      timeWindow: "Ønsket tidsrum",
      timeAny: "Fleksibel",
      timeMorning: "Formiddag (08–12)",
      timeAfternoon: "Eftermiddag (12–16)",
      timeEvening: "Sen eftermiddag (16–19)",
      comments: "Kommentarer",
      commentsPh: "Fx særlige forhold, adgang, etage, elevator...",
      consentLabel:
        "Jeg accepterer, at mine oplysninger behandles med henblik på at behandle min henvendelse, jf. privatlivspolitikken.",
      summary: "Sammendrag",
      service: "Ydelse",
      yourPrice: "Din pris (inkl. moms)",
      priceOnQuote: "Pris oplyses i tilbud",
      successTitle: "Tak for din henvendelse!",
      successBooking:
        "Vi har modtaget din booking og vender tilbage hurtigst muligt for at bekræfte tidspunktet.",
      successQuote:
        "Vi har modtaget din anmodning og sender dig et tilbud hurtigst muligt.",
      done: "Færdig",
      errName: "Udfyld fornavn og efternavn.",
      errEmail: "Indtast en gyldig e-mail.",
      errPhone: "Indtast et telefonnummer.",
      errPostcode: "Indtast et postnummer.",
      errConsent: "Du skal acceptere behandling af dine oplysninger.",
    },
    upload: {
      drop: "Klik for at uploade eller træk filer hertil",
      types: "PDF, JPG, PNG (maks 15MB)",
      errEmpty: "Filen ser ud til at være tom (ingen tekst, tegning eller billede). Tjek filen og upload den igen.",
      errCorrupt: "Filen kunne ikke læses (den kan være beskadiget). Prøv at gemme den igen og upload den på ny.",
      uploading: "Uploader...",
      uploaded: "Uploadet",
    },
    footer: {
      tagline: "Uafhængig dansk montageservice til IKEA-møbler.",
      services: "Ydelser",
      company: "Virksomhed",
      contact: "Kontakt",
      legal: "Juridisk",
      privacy: "Privatlivspolitik",
      terms: "Handelsbetingelser",
      cookies: "Cookies",
      contactPage: "Kontakt",
      disclaimer:
        "er en selvstændig montageservice og er ikke ejet af, godkendt af, i partnerskab med eller officielt tilknyttet IKEA. IKEA®, PAX® og KOMPLEMENT® er varemærker tilhørende Inter IKEA Systems B.V. Vi bruger disse navne udelukkende til at beskrive de møbler, vi samler.",
      rights: "Alle rettigheder forbeholdes.",
    },
    cookie: {
      text: "Vi bruger nødvendige cookies for at siden fungerer, og valgfrie cookies til statistik. Du kan læse mere i vores cookiepolitik.",
      accept: "Accepter alle",
      necessary: "Kun nødvendige",
    },
    contact: {
      title: "Kontakt os",
      subtitle: "Har du spørgsmål? Skriv eller ring til os.",
      email: "E-mail",
      phone: "Telefon",
      sms: "SMS / beskeder",
      city: "By",
      cvr: "CVR",
    },
    legalPages: {
      privacyTitle: "Privatlivspolitik",
      termsTitle: "Handelsbetingelser",
      lastUpdated: "Senest opdateret",
      companyInfoTitle: "Virksomhedsoplysninger",
      placeholderNote:
        "Denne tekst er en foreløbig skabelon. Endelige juridiske oplysninger og virksomhedsdata indsættes af virksomheden.",
    },
    seo: {
      pax: {
        introTitle: "Professionel montering af IKEA PAX garderobeskabe",
        introText:
          "Få hjælp til montering af dit IKEA PAX garderobeskab i København og Nordsjælland. Vi monterer PAX stel, hængslede døre, skuffer, hylder, bøjlestænger og KOMPLEMENT indretning. Du kan uploade din IKEA plan eller ordre og få beregnet en samlet pris på monteringen.",
        whatTitle: "Hvad kan vi montere i din PAX garderobe?",
        whatItems: ["PAX stel", "Hængslede døre", "KOMPLEMENT skuffer", "Hylder og bøjlestænger", "Trådkurve og udtræksbakker", "Bukseudtræk og anden KOMPLEMENT indretning"],
        howTitle: "Sådan får du en pris på PAX montering",
        howSteps: [
          "Upload din IKEA PAX plan, ordre eller PDF.",
          "Kontrollér de dele, som systemet har fundet.",
          "Se din samlepris eller send oplysningerne til os, hvis løsningen kræver manuel vurdering.",
        ],
        cta: "Få din samlepris",
        faqTitle: "Ofte stillede spørgsmål om PAX montering",
        faqs: [
          { q: "Hvad koster montering af IKEA PAX?", a: "Prisen afhænger af antallet af stel, døre og indvendige komponenter. Brug prisberegneren ovenfor, så får du en samlet pris på netop din opstilling." },
          { q: "Kan I montere skuffer, hylder og KOMPLEMENT indretning?", a: "Ja. Skuffer, hylder, bøjlestænger og KOMPLEMENT indretning kan indgå som en del af PAX monteringen." },
          { q: "Kan jeg uploade min IKEA PAX plan?", a: "Ja. Du kan uploade din IKEA plan, ordre eller PDF, så vi kan hjælpe med at identificere din opstilling og de dele, der skal monteres." },
          { q: "Monterer I PAX med skydedøre?", a: "PAX med skydedøre kan kræve en manuel vurdering, da monteringens kompleksitet varierer fra opstilling til opstilling. Send os oplysningerne, så vender vi tilbage med en pris." },
          { q: "Hvor tilbyder I PAX montering?", a: "Vi tilbyder PAX montering i København, Nærum, Lyngby, Hellerup, Gentofte, Rudersdal og resten af Nordsjælland." },
        ],
        areaLinkLabel: "Se hele vores serviceområde",
      },
      home: {
        blocksTitle: "Vores IKEA monteringsydelser",
        blocks: [
          { title: "IKEA PAX montering", text: "Montering af PAX garderobeskabe med stel, døre, skuffer og KOMPLEMENT indretning. Upload din plan og få en samlepris.", to: "/pax-montering", link: "Se PAX montering" },
          { title: "IKEA køkken montering", text: "Upload din IKEA køkkenplan eller PDF, så gennemgår vi projektet, inden du får et tilbud.", to: "/ikea-koekken", link: "Se køkkenmontering" },
          { title: "Montering af andre IKEA møbler", text: "Senge, garderobeskabe, kommoder, reoler og andre fladpakkede IKEA møbler.", to: "/oevrige-moebler", link: "Se øvrige møbler" },
        ],
        localTitle: "IKEA montering i København og Nordsjælland",
        localText: "Belov Multiservice tilbyder montering af IKEA møbler i København, Nærum og de omkringliggende områder i Nordsjælland.",
        localLink: "Se vores serviceområde",
      },
      kitchen: {
        aboutTitle: "Montering af IKEA køkken",
        aboutText: "Du kan sende eller uploade din IKEA køkkenplan eller PDF, så vi kan gennemgå projektet, inden du får et tilbud.",
        worksIntro: "Relevant monteringsarbejde kan for eksempel omfatte:",
        worksItems: ["køkkenskabe", "låger og skuffer", "sokler", "sidepaneler", "standardbordplader"],
        worksNote: "Arbejde, der kræver en autoriseret elektriker eller VVS-installatør, er ikke inkluderet, medmindre det aftales særskilt med en relevant autoriseret fagperson.",
        howTitle: "Sådan får du et tilbud på køkkenmontering",
        howSteps: [
          "Upload din IKEA køkkenplan eller PDF.",
          "Vi gennemgår skabe, indretning, bordplade og projektets omfang.",
          "Du modtager et tilbud baseret på det konkrete projekt.",
        ],
        faqTitle: "Ofte stillede spørgsmål om køkkenmontering",
        faqs: [
          { q: "Hvad koster montering af et IKEA køkken?", a: "Prisen afhænger af projektets omfang — antal skabe, bordplade, indretning og det aftalte arbejde. Du får et tilbud, når vi har gennemgået din køkkenplan." },
          { q: "Kan jeg sende min IKEA køkkenplan?", a: "Ja. Du kan uploade din IKEA køkkenplan eller PDF, så vi kan gennemgå projektet og give et præcist tilbud." },
          { q: "Monterer I bordplader?", a: "Ja. Vi monterer standardbordplader som en del af køkkenmonteringen. Særlige bordplader vurderes ud fra det konkrete projekt." },
          { q: "Hvad med el og VVS?", a: "Arbejde, der kræver en autoriseret elektriker eller VVS-installatør, er ikke inkluderet og udføres kun, hvis det aftales særskilt med en relevant autoriseret fagperson." },
          { q: "Hvor udfører I køkkenmontering?", a: "Vi udfører køkkenmontering i København og Nordsjælland." },
        ],
      },
      other: {
        aboutTitle: "Montering af IKEA møbler",
        aboutIntro: "Vi monterer mange typer IKEA møbler, for eksempel:",
        items: ["senge", "kommoder", "reoler", "skabe", "borde", "opbevaringsmøbler"],
        uploadText: "Du kan uploade en IKEA ordre, produktliste eller andet relevant dokument, så vi kan gennemgå opgaven.",
        paxText: "Skal du have monteret et PAX garderobeskab? Se vores dedikerede side om",
        paxLink: "PAX montering",
      },
      area: {
        introText: "Vores primære serviceområde er København og Nordsjælland.",
        citiesTitle: "Områder vi dækker",
        cities: ["København", "Nærum", "Lyngby", "Holte", "Virum", "Hellerup", "Gentofte", "Rudersdal", "Birkerød", "Hørsholm", "Farum", "Frederiksberg", "Ballerup"],
        outsideText: "Bor du uden for de nævnte områder, er du velkommen til at sende en henvendelse, så vurderer vi, om vi kan hjælpe.",
        linksTitle: "Se også",
      },
    },
    admin: {
      loginTitle: "Вход администратора",
      email: "E-mail",
      password: "Пароль",
      login: "Войти",
      loggingIn: "Вход...",
      logout: "Выйти",
      dashboard: "Панель управления",
      tabs: { leads: "Заявки", pricing: "Цены", zones: "Зоны", settings: "Настройки", stats: "Статистика" },
    },
  },

  en: {
    langName: "English",
    nav: {
      pax: "PAX assembly",
      other: "Other IKEA furniture",
      kitchen: "IKEA kitchen",
      area: "Service area",
      how: "How it works",
      cta: "Get your assembly price",
      menu: "Menu",
    },
    common: {
      inclVat: "incl. 25% VAT",
      vatBadge: "All prices incl. 25% VAT",
      from: "From",
      postcode: "Postcode",
      getPrice: "Get your assembly price",
      book: "Book assembly",
      requestQuote: "Request a quote",
      next: "Next",
      back: "Back",
      submit: "Send request",
      submitting: "Sending...",
      optional: "optional",
      required: "required",
      loading: "Loading...",
      close: "Close",
    },
    hero: {
      eyebrow: "Independent Danish assembly service",
      subtitle:
        "Professional assemblers put together your IKEA furniture quickly, safely and at a fixed price. Get your price in under a minute — no obligation.",
      point1: "Fixed price — no surprises",
      point2: "Experienced assemblers with their own tools",
      point3: "Wall mounting included for safety",
      ctaSecondary: "See how it works",
    },
    how: {
      title: "How it works",
      subtitle: "Four simple steps from booking to finished furniture.",
      step1Title: "Choose furniture type",
      step1: "Tell us which IKEA furniture you've had delivered.",
      step2Title: "Get your price",
      step2: "PAX is instant. For other items we send a quick quote.",
      step3Title: "Pick a date",
      step3: "Enter your postcode and choose a time that suits you.",
      step4Title: "We assemble",
      step4: "An experienced assembler puts it together — you relax.",
    },
    services: {
      title: "Our assembly services",
      subtitle: "We specialise in IKEA furniture assembly.",
      paxTitle: "PAX wardrobe",
      paxDesc: "Get a fixed price instantly with our calculator.",
      paxCta: "Calculate PAX price",
      otherTitle: "Other IKEA furniture",
      otherDesc: "Beds, dressers, shelving, sofas, tables and much more.",
      otherCta: "Request a quote",
      kitchenTitle: "IKEA kitchen",
      kitchenDesc: "Assembly and installation based on an agreed scope.",
      kitchenCta: "Request kitchen quote",
      instant: "Instant price",
      quote: "Quote",
    },
    why: {
      title: "Why choose us",
      subtitle: "A reliable local service focused on quality.",
      item1Title: "Fixed-price guarantee",
      item1: "You know the price before we start. No nasty surprises.",
      item2Title: "Experienced assemblers",
      item2: "Skilled assemblers with professional tools and IKEA experience.",
      item3Title: "Safe assembly",
      item3: "Wall mounting of tall furniture is included for safety.",
      item4Title: "Independent service",
      item4: "We are an independent business — not affiliated with IKEA.",
    },
    area: {
      title: "Service area",
      subtitle: "We primarily cover Copenhagen and North Zealand. Other areas of Zealand by arrangement. Check your postcode.",
      placeholder: "Enter postcode",
      check: "Check",
      supported: "We cover your area",
      supportedFee: "Travel to this area:",
      free: "Free travel",
      notSupported: "We don't cover this postcode yet. Feel free to contact us.",
      invalid: "Enter a valid Danish postcode.",
      zone: "Zone",
    },
    gallery: {
      title: "Selected work",
      subtitle: "Examples of assembly we carry out day to day.",
    },
    faq: {
      title: "Frequently asked questions",
      q1: "How much does PAX wardrobe assembly cost?",
      a1: "The price depends on the number of sections, doors, drawers and accessories. Use our calculator for an instant fixed price — incl. 25% VAT.",
      q2: "Do you deliver the furniture?",
      a2: "No. We assemble the IKEA furniture you've already had delivered. This keeps the price low and simple.",
      q3: "Are you affiliated with IKEA?",
      a3: "No. We are an independent assembly service with no affiliation to IKEA.",
      q4: "Do you fasten furniture to the wall?",
      a4: "Yes. Wall mounting of tall furniture is included for safety where relevant.",
      q5: "How do I pay?",
      a5: "You receive a confirmation with the fixed price. Payment is arranged when booking.",
    },
    finalCta: {
      title: "Ready to get your furniture assembled?",
      subtitle: "Get your fixed price in under a minute.",
    },
    pax: {
      heroTitle: "PAX wardrobe assembly",
      heroSubtitle:
        "Get an instant fixed price for assembling your PAX wardrobe. Configure your setup below.",
      calcTitle: "PAX price calculator",
      calcSubtitle: "Choose your setup — the price updates automatically.",
      sections: "Number of PAX sections (frames)",
      frameWidth: "Width per section",
      frameHeight: "Height",
      hingedDoors: "Hinged doors",
      slidingDoors: "Sliding door sets",
      drawers: "KOMPLEMENT drawers",
      baskets: "Mesh baskets",
      shelves: "Shelves",
      rails: "Clothes rails",
      handles: "Handles/knobs",
      lighting: "Lighting kits",
      wallMounting: "Wall mounting (recommended)",
      wallMountingIncluded: "Included",
      yourPrice: "Your price",
      priceNote: "Fixed price incl. 25% VAT",
      breakdown: "Price breakdown",
      travel: "Travel",
      discount: "Discount",
      belowMin: "Minimum order per job is",
      enterPostcode: "Enter your postcode to see the final price incl. travel.",
      notSupported: "We don't cover this postcode yet — feel free to contact us.",
      bookThis: "Book this setup",
      cm: "cm",
      chooseMethod: "Get your PAX assembly price",
      chooseSubtitle: "Pick the easiest way for you.",
      uploadOption: "Upload your IKEA order or PAX plan",
      uploadFast: "Fastest way",
      uploadDesc: "We'll find the parts and calculate the assembly price for you.",
      uploadPdf: "Upload PDF",
      uploadPhoto: "Upload screenshot/photo",
      orManual: "Or calculate manually",
      manualOption: "Calculate manually",
      recommended: "Recommended",
      analyzing: "Analyzing your order...",
      recognizeFailed: "Couldn't read the file. Try another file or calculate manually.",
      foundTitle: "We found the following",
      foundSubtitle: "Confirm or correct the quantities before we calculate the price.",
      recognizedItems: "Recognized items",
      lowConfidence: "Uncertain recognition — please check",
      confirmContinue: "Confirm and see price",
      editManually: "Edit manually",
      startOver: "Start over",
      trays: "Pull-out trays",
      trouserHangers: "Pull-out trouser hangers",
      multiHangers: "Pull-out multi-use hangers",
      otherPullouts: "Other pull-out/mechanism",
      otherUnknown: "Other / unknown item",
      infoOnly: "Info only — does not affect price",
      includedNote: "Standard price includes frames, doors, handles, shelves, rails and normal KOMPLEMENT fittings.",
      interiorTitle: "Interior (KOMPLEMENT)",
      doorsTitle: "Doors",
      fixedPrice: "Fixed assembly price",
      preliminaryPrice: "Preliminary assembly price",
      fixedNote: "Fixed price incl. 25% VAT",
      preliminaryNote: "Final price requires a quick confirmation",
      reasonHeavy: "Heavy pull-out interior detected",
      reasonSliding: "Sliding doors detected. We'll confirm the final price before you book.",
      reasonLighting: "Lighting/electrical detected",
      reasonUnknown: "Unknown item detected",
      reasonLarge: "Large order — requires internal review",
      reasonLowConfidence: "Uncertain recognition — confirmed manually",
      mirrorDoors: "Mirror doors (hinged)",
      handles: "Handles",
      shoeShelf: "Pull-out shoe shelf",
      frameDividers: "KOMPLEMENT frame divider",
      cornerSections: "Corner section",
      packagingTitle: "Packaging",
      packagingRemoval: "Packaging removal (haul-away)",
      packagingKeep: "Without removal we neatly stack the packaging in one spot at your place.",
      inclVat: "incl. 25% VAT",
      reviewIntro: "This configuration requires a quick confirmation:",
      bookPreliminary: "Request confirmed price",
    },
    other: {
      heroTitle: "Assembly of other IKEA furniture",
      heroSubtitle:
        "Beds, dressers, shelving, sofas, tables and more. Tell us what you have and we'll send a quick quote.",
      productsTitle: "Which furniture needs assembly?",
      addProduct: "Add item",
      productName: "Product name (e.g. MALM, HEMNES, BILLY)",
      articleNo: "IKEA article number",
      qty: "Qty",
      remove: "Remove",
      uploadTitle: "Upload IKEA order or photos",
      uploadDesc:
        "Feel free to upload your IKEA order confirmation (PDF/screenshot) or photos of the furniture. It helps us give an accurate quote.",
      uploadStep: "1. Upload your IKEA order",
      uploadHint: "IKEA order confirmation, product list, screenshot or photo (PDF/JPG/PNG). Our AI reads the items — it never calculates the price.",
      analyze: "Analyze order",
      analyzing: "Analyzing…",
      analyzeFailed: "Couldn't analyze the file. Please add the items manually.",
      fillManually: "Fill in manually",
      recognizedTitle: "We recognized the following items",
      recognizedHint: "Correct quantities, remove wrong items or add ones we missed.",
      lowConfidence: "Some items are uncertain — please check them.",
      successMsg: "Thank you — we have received your IKEA order. We will review it and send you a fixed assembly price before the work is booked.",
      quoteNote:
        "We provide a fixed quote based on your details. The price is confirmed before we start.",
    },
    kitchen: {
      heroTitle: "IKEA kitchen assembly & installation",
      heroSubtitle:
        "We assemble and install your IKEA kitchen based on an agreed scope of work.",
      scopeTitle: "What should the job include?",
      scopeSubtitle: "Select the tasks relevant to your project.",
      uploadTitle: "Upload kitchen project & photos",
      uploadDesc:
        "Upload your IKEA Kitchen Planner/project, product/order list and photos of the room.",
      scopeNotice:
        "Kitchen pricing is based on the confirmed scope of work. Additional work discovered or requested during installation is not included unless separately approved.",
      legalNotice:
        "Note: Electrical and plumbing work is only performed where legally appropriate and explicitly agreed, by authorised professionals.",
      requestQuote: "Request installation quote",
      uploadStep: "1. Upload your kitchen project",
      uploadHint: "IKEA Kitchen Planner (PDF), drawing, product list, screenshots and optional room photos.",
      analyze: "Analyze project",
      analyzing: "Analyzing project...",
      analyzeFailed: "Couldn't analyze the file. Please fill in manually.",
      fillManually: "Fill in manually",
      summaryStep: "2. We found the following — please correct",
      summaryHint: "Confirm or correct the details. AI does not calculate a price.",
      layoutLabel: "Kitchen layout",
      layouts: { straight: "Straight", l: "L-shaped", u: "U-shaped", island: "Island", peninsula: "Peninsula", other: "Other", unknown: "Not sure" },
      baseCabinets: "Base cabinets", wallCabinets: "Wall cabinets", tallCabinets: "Tall cabinets", cornerCabinets: "Corner cabinets",
      worktop: "Worktops", worktopLength: "Worktop length (cm, if known)", sink: "Sink", oven: "Oven", hob: "Hob",
      dishwasher: "Dishwasher", fridge: "Fridge/freezer", hood: "Extractor hood", island: "Kitchen island", coverPanels: "Cover/side panels",
      plinth: "Plinth", lightingK: "Lighting", otherUnknown: "Other / unknown",
      recognizedItems: "Recognized items",
      lowConfidence: "Some items are uncertain — please check.",
      questionsStep: "3. A few quick questions",
      qOldKitchen: "Should the old kitchen be removed?",
      qWorktopInstall: "Should the worktop be installed?",
      qSinkCutout: "Sink cut-out needed?",
      qHobCutout: "Hob cut-out needed?",
      qWallsReady: "Are the walls ready (painted/prepared)?",
      qAppliances: "Appliances to install",
      qAppliancesPh: "E.g. oven, hob, hood, dishwasher, fridge...",
      optYes: "Yes", optNo: "No", optNotSure: "Not sure", optNoOld: "No old kitchen",
      contactStep: "4. Send your project",
      sendProject: "Send project",
      regulatedNote: "Plumbing and electrical work is flagged for manual review and only performed by authorised professionals if separately agreed.",
      successMsg: "Thank you — we have received your kitchen project. We will review it and send you a fixed installation price before the work is booked.",
      noPriceNote: "The kitchen price is set manually after we review your project — you receive a fixed price before the work is booked.",
      scopeItems: {
        cabinet_assembly: "Cabinet assembly",
        cabinet_installation: "Cabinet installation",
        wall_cabinets: "Wall cabinets",
        base_cabinets: "Base cabinets",
        tall_cabinets: "Tall cabinets",
        cover_panels: "Cover panels",
        fillers: "Fillers",
        plinth: "Plinth/toe kick",
        worktop_install: "Worktop installation",
        worktop_cutting: "Worktop cutting",
        sink: "Sink installation",
        faucet: "Faucet installation",
        dishwasher: "Dishwasher installation",
        oven: "Oven installation",
        hob: "Hob installation",
        hood: "Extractor hood installation",
        fridge: "Refrigerator installation",
        lighting: "Lighting",
        removal_old: "Removal of old kitchen",
        plumbing: "Plumbing changes",
        electrical: "Electrical work",
        other: "Other special work",
      },
    },
    booking: {
      title: "Book assembly",
      quoteTitle: "Request a quote",
      step: "Step",
      of: "of",
      contactTitle: "Your contact details",
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone",
      postcode: "Postcode",
      address: "Address",
      addressNote: "Only used to plan the visit.",
      dateTitle: "Preferred date & time",
      preferredDate: "Preferred date",
      timeWindow: "Preferred time window",
      timeAny: "Flexible",
      timeMorning: "Morning (08–12)",
      timeAfternoon: "Afternoon (12–16)",
      timeEvening: "Late afternoon (16–19)",
      comments: "Comments",
      commentsPh: "E.g. special conditions, access, floor, elevator...",
      consentLabel:
        "I agree that my details are processed in order to handle my request, per the privacy policy.",
      summary: "Summary",
      service: "Service",
      yourPrice: "Your price (incl. VAT)",
      priceOnQuote: "Price provided in quote",
      successTitle: "Thank you for your request!",
      successBooking:
        "We've received your booking and will get back to you shortly to confirm the time.",
      successQuote:
        "We've received your request and will send you a quote as soon as possible.",
      done: "Done",
      errName: "Please enter first and last name.",
      errEmail: "Please enter a valid email.",
      errPhone: "Please enter a phone number.",
      errPostcode: "Please enter a postcode.",
      errConsent: "You must agree to the processing of your details.",
    },
    upload: {
      drop: "Click to upload or drag files here",
      types: "PDF, JPG, PNG (max 15MB)",
      errEmpty: "The file appears to be empty (no text, drawing or image). Please check the file and upload it again.",
      errCorrupt: "The file could not be read (it may be damaged). Please save it again and re-upload.",
      uploading: "Uploading...",
      uploaded: "Uploaded",
    },
    footer: {
      tagline: "Independent Danish assembly service for IKEA furniture.",
      services: "Services",
      company: "Company",
      contact: "Contact",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      cookies: "Cookies",
      contactPage: "Contact",
      disclaimer:
        "is an independent assembly service and is not owned by, endorsed by, partnered with or officially affiliated with IKEA. IKEA®, PAX® and KOMPLEMENT® are trademarks of Inter IKEA Systems B.V. We use these names solely to describe the furniture we assemble.",
      rights: "All rights reserved.",
    },
    cookie: {
      text: "We use necessary cookies to make the site work, and optional cookies for statistics. Read more in our cookie policy.",
      accept: "Accept all",
      necessary: "Necessary only",
    },
    contact: {
      title: "Contact us",
      subtitle: "Have a question? Write or call us.",
      email: "Email",
      phone: "Phone",
      sms: "SMS / messages",
      city: "City",
      cvr: "VAT no.",
    },
    legalPages: {
      privacyTitle: "Privacy Policy",
      termsTitle: "Terms & Conditions",
      lastUpdated: "Last updated",
      companyInfoTitle: "Company information",
      placeholderNote:
        "This text is a preliminary template. Final legal information and company data will be inserted by the company.",
    },
    seo: {
      pax: {
        introTitle: "Professional assembly of IKEA PAX wardrobes",
        introText:
          "Get help assembling your IKEA PAX wardrobe in Copenhagen and North Zealand. We assemble PAX frames, hinged doors, drawers, shelves, clothes rails and KOMPLEMENT interior. You can upload your IKEA plan or order and get a total price for the assembly.",
        whatTitle: "What can we assemble in your PAX wardrobe?",
        whatItems: ["PAX frames", "Hinged doors", "KOMPLEMENT drawers", "Shelves and clothes rails", "Mesh baskets and pull-out trays", "Trouser hangers and other KOMPLEMENT interior"],
        howTitle: "How to get a price for PAX assembly",
        howSteps: [
          "Upload your IKEA PAX plan, order or PDF.",
          "Check the parts the system has found.",
          "See your total price or send the details to us if the setup requires a manual assessment.",
        ],
        cta: "Get your assembly price",
        faqTitle: "Frequently asked questions about PAX assembly",
        faqs: [
          { q: "How much does IKEA PAX assembly cost?", a: "The price depends on the number of frames, doors and interior components. Use the calculator above to get a total price for your exact setup." },
          { q: "Can you assemble drawers, shelves and KOMPLEMENT interior?", a: "Yes. Drawers, shelves, clothes rails and KOMPLEMENT interior can be included as part of the PAX assembly." },
          { q: "Can I upload my IKEA PAX plan?", a: "Yes. You can upload your IKEA plan, order or PDF so we can help identify your setup and the parts to be assembled." },
          { q: "Do you assemble PAX with sliding doors?", a: "PAX with sliding doors may require a manual assessment, as the complexity of the installation varies from setup to setup. Send us the details and we'll get back to you with a price." },
          { q: "Where do you offer PAX assembly?", a: "We offer PAX assembly in Copenhagen, Nærum, Lyngby, Hellerup, Gentofte, Rudersdal and the rest of North Zealand." },
        ],
        areaLinkLabel: "See our full service area",
      },
      home: {
        blocksTitle: "Our IKEA assembly services",
        blocks: [
          { title: "IKEA PAX assembly", text: "Assembly of PAX wardrobes with frames, doors, drawers and KOMPLEMENT interior. Upload your plan and get a total price.", to: "/pax-montering", link: "See PAX assembly" },
          { title: "IKEA kitchen assembly", text: "Upload your IKEA kitchen plan or PDF and we'll review the project before you get a quote.", to: "/ikea-koekken", link: "See kitchen assembly" },
          { title: "Assembly of other IKEA furniture", text: "Beds, wardrobes, dressers, shelving and other flat-pack IKEA furniture.", to: "/oevrige-moebler", link: "See other furniture" },
        ],
        localTitle: "IKEA assembly in Copenhagen and North Zealand",
        localText: "Belov Multiservice offers assembly of IKEA furniture in Copenhagen, Nærum and the surrounding areas of North Zealand.",
        localLink: "See our service area",
      },
      kitchen: {
        aboutTitle: "IKEA kitchen assembly",
        aboutText: "You can send or upload your IKEA kitchen plan or PDF so we can review the project before you get a quote.",
        worksIntro: "Relevant assembly work may for example include:",
        worksItems: ["kitchen cabinets", "doors and drawers", "plinths", "side panels", "standard worktops"],
        worksNote: "Work requiring an authorised electrician or plumber is not included unless separately arranged with an appropriately authorised professional.",
        howTitle: "How to get a quote for kitchen assembly",
        howSteps: [
          "Upload your IKEA kitchen plan or PDF.",
          "We review cabinets, interior, worktop and the scope of the project.",
          "You receive a quote based on the specific project.",
        ],
        faqTitle: "Frequently asked questions about kitchen assembly",
        faqs: [
          { q: "How much does IKEA kitchen assembly cost?", a: "The price depends on the scope of the project — number of cabinets, worktop, interior and the agreed work. You receive a quote once we have reviewed your kitchen plan." },
          { q: "Can I send my IKEA kitchen plan?", a: "Yes. You can upload your IKEA kitchen plan or PDF so we can review the project and provide an accurate quote." },
          { q: "Do you install worktops?", a: "Yes. We install standard worktops as part of the kitchen assembly. Special worktops are assessed based on the specific project." },
          { q: "What about electrical and plumbing?", a: "Work requiring an authorised electrician or plumber is not included and is only carried out if separately arranged with an appropriately authorised professional." },
          { q: "Where do you carry out kitchen assembly?", a: "We carry out kitchen assembly in Copenhagen and North Zealand." },
        ],
      },
      other: {
        aboutTitle: "Assembly of IKEA furniture",
        aboutIntro: "We assemble many types of IKEA furniture, for example:",
        items: ["beds", "dressers", "shelving", "wardrobes", "tables", "storage furniture"],
        uploadText: "You can upload an IKEA order, product list or other relevant document so we can review the job.",
        paxText: "Need a PAX wardrobe assembled? See our dedicated page about",
        paxLink: "PAX assembly",
      },
      area: {
        introText: "Our primary service area is Copenhagen and North Zealand.",
        citiesTitle: "Areas we cover",
        cities: ["København", "Nærum", "Lyngby", "Holte", "Virum", "Hellerup", "Gentofte", "Rudersdal", "Birkerød", "Hørsholm", "Farum", "Frederiksberg", "Ballerup"],
        outsideText: "If you live outside the listed areas, you are still welcome to send a request so we can assess availability.",
        linksTitle: "See also",
      },
    },
    admin: {
      loginTitle: "Вход администратора",
      email: "E-mail",
      password: "Пароль",
      login: "Войти",
      loggingIn: "Вход...",
      logout: "Выйти",
      dashboard: "Панель управления",
      tabs: { leads: "Заявки", pricing: "Цены", zones: "Зоны", settings: "Настройки", stats: "Статистика" },
    },
  },
};

export const PAX_ITEM_LABELS = {
  da: {
    frames: "PAX-sektioner", hinged_doors: "Hængslede låger", sliding_door_sets: "Skydedørssæt",
    drawers: "KOMPLEMENT skuffer", baskets: "Trådkurve", shelves: "Hylder", rails: "Bøjlestænger",
    handles: "Håndtag", lighting: "Lyspakker", wall_mounting: "Vægfæstning",
  },
  en: {
    frames: "PAX sections", hinged_doors: "Hinged doors", sliding_door_sets: "Sliding door sets",
    drawers: "KOMPLEMENT drawers", baskets: "Mesh baskets", shelves: "Shelves", rails: "Clothes rails",
    handles: "Handles", lighting: "Lighting kits", wall_mounting: "Wall mounting",
  },
};
